import { UPDATE_EVH_MARKER_DATA } from "./evhMarkerDataReducer"

export const updateEvhMarkerData = (info) => ({
    type: UPDATE_EVH_MARKER_DATA,
    payload: info
})